import { render, staticRenderFns } from "./RedPacketCreatePrizePane.vue?vue&type=template&id=0fd44dfb&scoped=true"
import script from "./RedPacketCreatePrizePane.vue?vue&type=script&lang=js"
export * from "./RedPacketCreatePrizePane.vue?vue&type=script&lang=js"
import style0 from "./RedPacketCreatePrizePane.vue?vue&type=style&index=0&id=0fd44dfb&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd44dfb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd44dfb')) {
      api.createRecord('0fd44dfb', component.options)
    } else {
      api.reload('0fd44dfb', component.options)
    }
    module.hot.accept("./RedPacketCreatePrizePane.vue?vue&type=template&id=0fd44dfb&scoped=true", function () {
      api.rerender('0fd44dfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/red_packet/components/RedPacketCreatePrizePane.vue"
export default component.exports